<template>
  <div class="form-footer floating-labels-form">
    <div v-if="isSocialIconsVisible" class="socials">
      <ul>
        <li class="social-circle facebook">
          <a id="sfiFacebook"
             v-utd-new-tab="true"
             class="wkce-icon-filled-facebook"
             href="https://www.facebook.com/UpToDateEBM"
             aria-label="UpToDate Facebook" />
        </li>
        <li class="social-circle twitter">
          <a id="sfiTwitter"
             v-utd-new-tab="true"
             class="wkce-icon-x"
             href="https://x.com/UpToDate"
             aria-label="UpToDate X (formerly Twitter)" />
        </li>
        <li class="social-circle youtube">
          <a id="sfiYoutube"
             v-utd-new-tab="true"
             class="wkce-icon-filled-youtube"
             href="https://www.youtube.com/uptodateebm"
             aria-label="UpToDate YouTube" />
        </li>
        <li class="social-circle linkedin">
          <a id="sfiLinkedIn"
             v-utd-new-tab="true"
             class="wkce-icon-filled-linkedin"
             href="https://www.linkedin.com/company/uptodate?trk=hb_tab_compy_id_21924"
             aria-label="UpToDate LinkedIn" />
        </li>
      </ul>
    </div>

    <div class="clear" />

    <div v-if="!isOidcUser" class="utd-login-footer">
      <p class="utd-about-us-link">
        <a v-if="isFooterLoaded"
           :href="getFooterUrl('aboutUs')"
           target="_blank">{{ $t('LOGIN.ABOUT_LINK') }}
        </a>
      </p>
      <utd-copyright-provider :full="true" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import UtdCopyrightProvider from '_acaSrc/components/shared/providers/UtdCopyrightProvider.vue';
import UtdNewTab from '_acaSrc/directives/UtdNewTab.directive';

export default {
    components: {
        UtdCopyrightProvider
    },
    directives: {
        UtdNewTab
    },
    computed: {
        ...mapGetters('device', [ 'isDesktopView' ]),
        ...mapGetters('auth', [ 'isOidcUser' ]),
        ...mapGetters('footer', [
            'getFooterUrl',
            'isFooterLoaded'
        ]),
        ...mapGetters('login', [
            'loginSubscriberBox'
        ]),
        isSocialIconsVisible() {
            return !this.isOidcUser && this.loginSubscriberBox && !this.isDesktopView;
        }
    }
};
</script>
<style lang="less" scoped>
@import '~_acaAssets/global/variables';
@import '~_acaAssets/wkce/colors/wkce-app-styles';

@SOCIAL-ICON-COLOR: @WKCE-GRAY-TINT1;

.utd-form {
  .utdWkHeader & {
    .utd-login-footer {
      display: none;
    }
  }

  .socials {
    .ds1-pt-3();
    .ds1-pb-0();
    border-bottom: 0;

    > ul {
      .ds1-flex-vertical-center();
      .ds1-flex-horizontal-center();
      gap: 32px;

      > li.social-circle {
        .ds1-pa-0();
        .ds1-ma-0();
        width: auto;
        display: inline-block;

        > a {
          .ds1-pa-0();
          .ds1-ma-0();
          font-size: 24px;
          color: @SOCIAL-ICON-COLOR;
        }

        &:last-child {
          .ds1-pr-0();
        }

        // remove this once the font type gets updated with x icons
        &:has(> .wkce-icon-x) {
          // prevent element from shifting on hover
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;

          &:hover {
            /* stylelint-disable-next-line declaration-property-value-no-unknown */
            border-bottom: 2px solid @SOCIAL-ICON-COLOR;
          }

          > .wkce-icon-x {
            width: 24px;
            height: 24px;
            display: inline-block;
            background-color: @SOCIAL-ICON-COLOR;
            mask-image: url(~_acaAssets/footer/wk-icon-x.svg);
            mask-repeat: no-repeat;
            mask-size: cover;
          }
        }
      }
    }
  }

  .utd-about-us-link {
    padding-top: 15px;

    a {
      font-size: 14px;
      text-decoration: none;
      color: @WK_UTD_BLUE_HOVER;
    }
  }

  .utd-oidc-footer {
    bottom: 16px;
    position: absolute;

    > ul > li {
      display: inline-flex;

      > a {
        color: @DS1-UTD-GRAY-TEXT-COLOR;
      }
    }
  }

  .utd-oidc-footer-container {
    display: flex;
    justify-content: center;
  }
}

@media only screen and (min-width: 768px) {
  .isDesktop {
    .utd-form {
      .utd-login-footer {
        display: none;
      }
    }
  }
}
</style>
